import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { studentCheckLogin } from '../newMain/studentMain';
import { Pagination } from 'antd';
import './resources.css'

const StudentResources = () => {

    const history = useHistory();
    const [resourceList,setResourceList] = useState([])
    const [tablesCount, setTablesCount] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [current, setCurrent] = useState(1);
    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        search(pageSize,1);
    }, []);

    //查询
    const search = (pageSizeNew, currentPageNew) => {
        let model = {}
        model.page = currentPageNew;
        model.pageSize = pageSizeNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.recipientList = [
            'GENERAL',
            'STUDENT'
        ]
        Base.callBackApi("resource/searchAll",model).then((data) => {
            const resourceList = data.object?.list
            setCurrent(currentPageNew);
            setPageSize(pageSizeNew);
            setTablesCount(data?.object?.total ?? 0);
            setResourceList(resourceList)
        }).catch(err => { }).finally(() => { });
    }

    const jump = (path, resourceId) => {
        localStorage.setItem(Config.tokenPrefix + 'resourceId', resourceId);
        history.push(path);
    }

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a className='preva'>Previous</a>;
        }
        if (type === 'next') {
            return <a className='nexta'>Next</a>;
        }
        return originalElement;
    };

    const onChange = (currentNew, pageSizeNew) => {
        document.getElementById("container").scrollTop = 0;
        search(pageSizeNew, currentNew)
    }

    return (
        <div id="container" className="websiteTemplate studentResources">
            {/* 提示信息弹框 */}
            <div className='title'>
                <div>Resources</div>
            </div>
            <div>
                {
                    (resourceList && resourceList.length>0) &&
                    <div className='resourcesTitleList'>
                        {resourceList?.map((item,index) =>
                            <div key={item.resourceId} className='resourcesTitle' onClick={() => {jump('/student/resourcesContext', item.resourceId)}}>
                                {(index+1)+(current-1)*pageSize}.  {item.resourcePageName}
                            </div>
                        )}
                    </div>
                }
                {
                    tablesCount > pageSize && <div className="pagination" style={{ marginTop: '20px' }}>
                        <Pagination defaultCurrent={1}
                            current={current}
                            pageSize={pageSize}
                            total={tablesCount}
                            itemRender={itemRender}
                            showSizeChanger={false}
                            onChange={onChange}
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default StudentResources;